import { GroundTileType, WorldTile } from '../../types/tile/tile'

export const WaterTile: WorldTile = {
  type: GroundTileType.Water,
  posX: 1,
  posY: 2,
  rules: [],
}
